import { render } from "./ConstellationGraph.vue?vue&type=template&id=04c5e828&scoped=true"
import script from "./ConstellationGraph.vue?vue&type=script&lang=js"
export * from "./ConstellationGraph.vue?vue&type=script&lang=js"

import "./ConstellationGraph.vue?vue&type=style&index=0&id=04c5e828&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c5e828"]])

export default __exports__